angular.module('unergie.main')
.controller('dealsCtrl', ($rootScope, $scope, $state, $filter, $timeout, AccountService, AlertManager, DataAccess, DataAccessSearch, TableGeneratorService, MetaWatcher, DealStatuses,
    ReferencesService, BoFeaturesService, AdminComments, ErrorCatcher, ApiUser, AuthService) => {
    $scope.seniorAdvisor = BoFeaturesService.isFeatureOn('seniorAdvisor')
    $scope.isCrossOrg = BoFeaturesService.isFeatureOn('crossOrg')
    $scope.canAffectDeals = BoFeaturesService.isFeatureOn('canAffectDeals')
    $scope.displayDealsVendorName = BoFeaturesService.isFeatureOn('displayDealsVendorName')
    $scope.providerLabel = BoFeaturesService.get('providerLabel')
    $scope.showConsentsInDealsPage = BoFeaturesService.isFeatureOn('showConsentsInDealsPage')

    $scope.ouinon = [{ id: true, title: 'Oui' }, { id: false, title: 'Non' }]

    $scope.dealStatuses = _.map(DealStatuses, (conf, id) => ({ id, title: conf.title }))

    $scope.filterFields = [
        { value: undefined, label: '-- Pas de filtre --' },
        { value: 'draft_date', label: 'Contrats initialisés' },
        { value: 'contract_date', label: 'Contrats signés' },
        { value: 'commissioning_date', label: 'Contrats activés' },
    ]

    $scope.endDate = moment().add(1, 'day').endOf('day').unix()

    $scope.sliderOptions = {
        floor: moment().add(-6, 'month').unix(),
        ceil: $scope.endDate,
        step: 86400,
        enforceStep: true,
        showTicks: false,
        showTicksValues: false,
        disabled: true,
        translate(value) {
            return moment.unix(value).format('DD MMM YY')
        },
    }

    const loadFromLocalStorage = () => {
        if (localStorage.dealsPageConf) {
            const conf = JSON.parse(localStorage.dealsPageConf)
            $scope.startDate = conf.startDate
            $scope.filterField = conf.filterField
        } else {
            $scope.startDate = moment().add(-3, 'month').unix()
            $scope.filterField = undefined
        }
        $scope.sliderOptions.disabled = $scope.filterField === undefined
    }

    const storeInLocalStorage = () => {
        const conf = {
            startDate: $scope.startDate,
            endDate: $scope.endDate,
            filterField: $scope.filterField,
            search: $scope.deals.instance.filter(),
        }
        localStorage.dealsPageConf = JSON.stringify(conf)
    }

    loadFromLocalStorage()

    const unixToDate = () => {
        $scope.startDateInput = moment.unix($scope.startDate).toDate()
        $scope.endDateInput = moment.unix($scope.endDate).toDate()
    }

    unixToDate()

    $scope.dateToUnix = () => {
        $scope.startDate = moment($scope.startDateInput).unix()
        $scope.endDate = moment($scope.endDateInput).unix()
        $scope.refresh()
    }

    $scope.changeFilter = function () {
        $scope.sliderOptions.disabled = $scope.filterField === undefined
        $scope.refresh()
    }

    $scope.title = 'Mes affaires'
    if (AuthService.userHasGroup('advisor-admin')) {
        $scope.title = `Affaires ${AuthService.getAuth().organization}`
    }
    if (AuthService.userHasGroup(['data-admin', 'data-reader'])) {
        $scope.title = 'Affaires'
    }

    $scope.isContinuable = (deal) => ['DRAFT', 'PRM_KO', 'CLIENT_CHECKOUT', 'WITHOUT_PRM_ESTIMATION'].includes(deal.deal_status)

    $scope.isActive = (state) => $state.is(state)

    $scope.reRenderSlider = () => {
        $timeout(() => $rootScope.$broadcast('rzSliderForceRender'))
    }
    $scope.reRenderSlider()

    // CHANGE OWNER
    $scope.changeVendorFields = {
        vendor_id: {
            label: 'Vendeur',
            required: true,
            type: 'typeahead',
            limitTo: 20,
            enum: [],
        },
    }

    const refreshUsers = () => {
        DataAccess.users().$promise.then((data) => {
            const vendorList = []
            _.forEach(data, (d) => {
                let label = `${d.givenname} ${d.sn} ${$scope.isCrossOrg ? `(${d.organization})` : ''}`
                if (d.groups.indexOf('admin') > -1) {
                    label += ' (admin)'
                }
                vendorList.push({ value: d.id, label })
            })
            $scope.changeVendorFields.vendor_id.enum = _.orderBy(vendorList, 'label')
        })
    }
    refreshUsers()

    $scope.changeOwner = (deal) => {
        DataAccess.changeDealOwner({ id: deal.id_draft }, { vendorId: deal.vendor_id }).$promise.then(() => {
            AlertManager.success('Propriétaire modifié')
            $scope.refresh()
        }).catch(ErrorCatcher)
    }

    $scope.deals = {
        show: {},
        refreshing: false,
        columns: {
            'vendor': { label: 'Vendeur', mode: 'search_wildcard' },
            'vendor_org': { label: 'Organisation', mode: $scope.isCrossOrg ? 'search_wildcard' : 'hidden' },
            'draft_date': { label: 'Initialisation', mode: 'search_date' },
            'contract_date': { label: 'Transformation', mode: 'search_date' },
            'commissioning_date': { label: 'Activation', mode: 'search_date' },
            'client': { label: 'Client', mode: 'search_wildcard' },
            'mail': { label: 'Email', mode: 'search_wildcard' },
            'subscription_type': { label: 'Type', mode: 'search_wildcard' },
            'id_prm': { label: 'PRM', mode: 'search_wildcard', length: 14 },
            'metter_kind': { label: 'Type compteur', mode: 'search_wildcard' },
            'id_draft': { label: 'Id ébauche', mode: 'search_wildcard', length: 9 },
            'phone': { label: 'Téléphone', mode: 'search_wildcard' },
            'switch_readings': { label: 'Relève', mode: 'search_strict' },
            'deal_status': { label: 'Statut Affaire', mode: 'search_wildcard' },
            'next_rdv_date': { label: 'RDV pris', mode: 'search_date' },
            'past_rdv_date': { label: 'RDV pris', mode: 'hidden' },
            'id_contract': { label: 'Id contrat', mode: 'hidden', translateCsv: 'id_contract' },
            'id': { label: 'Id', mode: 'hidden', translateCsv: 'id' },
            'email_checked': { label: 'Email ok', mode: 'hidden', translateCsv: 'email_checked' },
            'civ': { label: 'Civilité', mode: 'hidden', translateCsv: 'civ' },
            'vendor_id': { label: 'Id vendeur', mode: 'hidden', translateCsv: 'vendor_id' },
            'is_a_move': { label: 'Déménagement', mode: 'hidden', translateCsv: 'is_a_move' },
            'plan_id': { label: 'Type offre', mode: 'hidden', translateCsv: 'plan_id' },
            'draft_modification_ts': { label: 'Achat groupé', mode: 'hidden', translateCsv: 'draft_modification_ts' },
            'checkout_mail_sent': { label: 'Mail envoyé', mode: 'hidden', translateCsv: 'checkout_mail_sent' },
            'retraction_end_date': { label: 'Date retractation', mode: 'hidden', translateCsv: 'retraction_end_date' },
            'contract_status': { label: 'Statut contrat', mode: 'hidden', translateCsv: 'contract_status' },
            'modification_ts': { label: 'Date de modification', mode: 'hidden', translateCsv: 'modification_ts' },
            'bulk_purchase': { label: 'Achat groupé', mode: 'hidden', translateCsv: 'bulk_purchase' },
            'draftElec.draftBasic.account_category': { label: 'Categorie client', mode: 'hidden', translateCsv: 'account_category' },
            'draftElec.id_draft_basic': { label: 'Id draft basic', mode: 'hidden' },
            'consents': { label: 'Consentement', mode: $scope.showConsentsInDealsPage ? 'search_strict' : 'hidden', csvIgnore: true },
        },
    }

    const transformData = function (data) {
        const defaultOrderBy = 'draft_modification_ts'
        let lastDate = null
        let alternate = false
        const dataResult = _.orderBy(data, defaultOrderBy, 'desc')
        dataResult.forEach((deal) => {
            if ((lastDate === null) || !moment(deal[defaultOrderBy]).startOf('day').isSame(lastDate)) {
                alternate = !alternate
                lastDate = moment(deal[defaultOrderBy]).startOf('day')
            }
            deal.alternate = alternate
        })
        return dataResult
    }


    const refresh = function () {
        if ($scope.deals.instance) {
            const search = $scope.deals.instance.filter()
            search.draft_date = undefined
            search.contract_date = undefined
            search.commissioning_date = undefined
            if ($scope.filterField) {
                search[$scope.filterField] = `${moment.unix($scope.startDate).format('DD/MM/YYYY')}<<${moment.unix($scope.endDate).format('DD/MM/YYYY')}`
            }
            $scope.deals.instance.filter = () => search
        }
        TableGeneratorService.getTable($scope.deals, 'deals', undefined, transformData, { orderBy: '-draft_modification_ts' })
    }

    $scope.refresh = refresh
    refresh()

    MetaWatcher.watch('TABLE_DEALS_DATA_CHANGED', 'readings', $scope, storeInLocalStorage)

    $scope.$on('slideEnded', () => $timeout(() => {
        unixToDate()
        $scope.refresh()
    }, 0))

    $scope.openDraft = (draft) => {
        const url = $state.href('salesTunnelV3', { draft: draft.id_draft_basic })
        window.open(url, '_blank')
    }
})
